import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Pagination, Form } from 'react-bootstrap';
import Service from '../assets/icon/management.png';
import Footer from '../../Components/Footer';

import { useHistory, Link } from 'react-router-dom';
import TabsIcon from '../Components/layout/TabsIcon';
import Calendar from '../assets/icon/calendar-bg.png';
import Back from '../assets/icon/back.png';
import Save from '../assets/icon/new-save.png';
import Return from '../assets/icon/return-value.png';
import Getout from '../assets/icon/getout.png';
import Increase from '../assets/icon/add-staff.png';
import Select, { components } from 'react-select';
import StockImage from 'assets/icon/appwizard_list.png'

import Delete from '../assets/icon/delete.png';
import { DatePicker, Space } from 'antd';

//API
import {ProductList} from 'actions/product';
import { UserList } from 'actions/user';
import { List } from 'actions/employee';
import { saveStorage, LoadNewStockCode } from 'actions/stock';
import { loadAuth } from 'actions/auth';
import {UnitSale} from 'actions/settings/unit'


import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';

export default function TransferStore() {
  const history = useHistory();
  const dispatch = useDispatch();

  const profileString = localStorage.getItem('profile');
  const profile =JSON.parse(profileString);

  const [statepage, setStatepage] = useState('');
  const [Products, setProducts] = useState('');

  const [transferBy, setTransferBy] = useState([{ value: '', label: '' }]);
  const handleSelectPage = (e) => setStatepage(e);
  const [isLoading,setIsLoading] = useState(false);
  const dateFormat = 'YYYY/MM/DD';
  const StorageModel = {
    key: 0,
    ProductId: null,
    TotalQuantity: 0,
    UnitName: null,
    Admit: false,
    TakeOut: true,
    Quantity: null,
    UnitType: null,
    UnitId: null,
    UnitSaleId: null,
    CountBy: null,
    Note: null,
    StockDate: null,
    reasonType: null,
    Type:'transfer',
  }
  const [Data,setData] = useState({
    StorageList:[
      StorageModel
    ],
  });
  const [User,setUser] = useState([]);
  const [validated, setValidated] = useState(false);
  //end state

  //start funcion
  const [unitSales, setUnitSales] = useState([]);
  async function getUnitSale(unit_id){
    setIsLoading(true)
    try {
      const params = {
        unit_id: unit_id,
      }
        const response = await dispatch(UnitSale(params));
        setUnitSales(response.data.data)
        setIsLoading(false)
      } catch (error) {
        console.error(error);
      } finally {
        console.log('finally')
      }

  }

  const [employees,setEmployees] = useState([]);
  const GetEmployees = async () => {
    setIsLoading(true);
    try {
      const params = {
        branch_id : profile.branch_id
      }
      const response = await dispatch(List(params));
      setEmployees(response.data.data);
      setIsLoading(false)
    } catch (error) {
      console.error(error);
    } finally {
      console.log('finally')
    }
  }

  function onChange(date, dateString) {
    console.log(date, dateString);
  }

  function closePage() {
    let path = `/stock`;
    history.push(path);
  }
  function SetTransferBy(data) {
    setTransferBy([{ value: data.value, label: data.value }]);
  }
  const OptionTransferBy = [{ value: 't1', label: 't1' }];

  const GetProduct = async () => {
    setIsLoading(true)
    try {
      const params = {

      }
      const response = await dispatch(ProductList(params));
      setProducts(response.data.data);
      setIsLoading(false)
    } catch (error) {
      console.error(error);
    } finally {
      console.log('finally')
    }
  }

  const GetUser = async () => {
    setIsLoading(true);
    try {
      const params = {
      }
      const response = await dispatch(UserList(params));
      setUser(response.data.data);
      setIsLoading(false)
    } catch (error) {
      console.error(error);
    } finally {
      console.log('finally')
    }
  }

  const InsertStorage = (key) => {
    let insert = StorageModel
    // insert.key = Data.StorageList.length
    insert.key = Number(key) + 1 
    setData({ ...Data, StorageList:[...Data.StorageList, insert]})
  }

  const RemoveStorage = (key) => {
    if(Data.StorageList.length > 1){
      const list = Data.StorageList
      const index = list.filter((item) => item.key !== key)
      const result = index
      setData({ ...Data, StorageList: result })
    }else{
      alert('ไม่สามารถลบได้ ต้องมีมากกว่า 1 รายการ')
    }
    
  }
  const [StockCode,setStockCode] = useState([]);
  async function getNewStockCode(){
    setIsLoading(true)
      try {
        const params = {
          type: 'adjust',
        }
        const response = await dispatch(LoadNewStockCode(params));
        setStockCode(response.data.data);
        setIsLoading(false)
    } catch (error) {
      console.error(error);
    } finally {
      console.log('finally')
    }
  }

  
  async function saveStorageList(e){
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    setValidated(true);
    // console.log('Data.StorageList',Data.StorageList);
    let formData = new FormData();
    if(Data.StorageList.length > 0){
      for (let i = 0; i < Data.StorageList.length; i++) {
        formData.append(`stock_list[${i}]`, JSON.stringify(Data.StorageList[i]));
      }
    }

    try {
      const response = await dispatch(saveStorage(formData));
     
      if(response){
        history.push(`/stock`);
      }else{
        console.log('failed')
      }
    } catch (error) {
      console.error(error);
    } finally {
      console.log('finally')
    }


  }

  const getAuth = async () => {
    try {
      const params = {
        name: ['ปรับ/ตัด(stock)'],
        permission : 'add',
      }
      const response = await dispatch(loadAuth(params));
      if(response.data.data === 'Unauthorized'){
        alert(response.data.message)
        history.push('/stock');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const OptionProduct = [{ value: 'น้ำยา', label: 'น้ำยา' }];

  const initialValues = {
    mainField: '',
    operation: '',
    value: [],
  };

  useEffect( () => {
    GetProduct();
    // GetEmployees();
    GetUser();
    getAuth()
    getNewStockCode()
    GetEmployees();
  },[]);

  return (
    <>
      <Container
        fluid
        className="package-container Service Stock CutStock bg-mrk"
      >
        <div className="package">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={StockImage} />
                  <Link to={`/stock`} className='mr-2'>Stock</Link> &gt; โอนไปหน้าร้าน
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closePage}
                >
                  <span aria-hidden="true">X</span>
                </button>
              </div>
              <div className="modal-header-mobile">
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closePage}
                >
                  <img src={Back} />
                </button>
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={StockImage} />
                  <Link to={`/stock`} className='mr-2'>Stock</Link> &gt; โอนไปหน้าร้าน
                </h5>
              </div>
              <div className="modal-body">
                <Row className="g-0 tabsicon justify-content-center ">
                  <TabsIcon />
                </Row>
                <Row className="g-0  justify-content-center  align-items-center   set-position">
                  <Col xs={12} lg={12}>
                    <Row className="mt-2 mb-2">
                      <Col xs={6} sm={6} lg={6} className="d-flex  text-left">
                        <Form.Label>เอกสารหมายเลข</Form.Label>
                      </Col>
                      <Col xs={6} sm={6} lg={6} className="d-flex text-left">
                        <p>: {StockCode}</p>
                      </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                      <Col xs={6} sm={6} lg={6} className="d-flex text-left">
                        <Form.Label>วันที่ตัด</Form.Label>
                      </Col>
                      <Col xs={6} sm={6} lg={6} className="d-flex text-left">
                        <p>: {dayjs().format('DD-MM-YYYY')}</p>
                      </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                      <Col xs={6} sm={6} lg={6} className="d-flex text-left">
                        <Form.Label>ผู้บันทึก</Form.Label>
                      </Col>
                      <Col xs={6} sm={6} lg={6} className="d-flex text-left">
                        <p>: {profile.fullname}</p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Form noValidate validated={validated} onSubmit={saveStorageList} style={{ height: '600px', overflowY: 'scroll' }} > 
                {
                    Data.StorageList?.map(  (item, key) => {
                      return (
                        <div>
                          <Row className="g-0 mt-4 mb-5">
                            <Col lg={11}>
                              <Row className="g-0">
                                <Col lg={9}>
                                  <Row>
                                    <Col
                                      xs={3}
                                      sm={3}
                                      lg={2}
                                      className="d-flex align-items-center justify-content-end set-Label"
                                    >
                                      <Form.Label>ชื่อสินค้า</Form.Label>
                                    </Col>
                                    <Col xs={9} lg={5}>
                                      <Select
                                        options={Products}
                                        getOptionLabel={option => option.name}
                                        getOptionValue={option => option.id}
                                        placeholder=""
                                        isClearable={false}
                                        isSearchable={false}
                                        className="select-list"
                                        value={item.ProductId ? Products.find((data) => {return data.id === item.ProductId}) : null}
                                        onChange={
                                          (data) => {setData(prevState => ({...Data,
                                            StorageList: prevState.StorageList.map(
                                              el => el.key === item.key ? { ...el, ProductId: data.id,
                                              TotalQuantity: data.total_quantity,
                                              UnitName : data.unit && data.unit.name_buy ? data.unit.name_buy : null,
                                              UnitId: data.unit_id, UnitSaleId: null
                                             }: el
                                            )
                                          }));getUnitSale(data.unit_id)}
                                        }
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      lg={4}
                                      className="d-flex align-items-center font-weight-bold"
                                    >
                                      <p>ยอดปัจจุบัน : {item.TotalQuantity ? item.TotalQuantity.toFixed(2) : 0} {item.UnitName} </p>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={9}>
                                  <Row className="align-items-center">
                                  <Col xs={3}
                                      lg={2} 
                                      className="d-flex align-items-center justify-content-end set-Label">
                                        <Form.Label>หน่วย</Form.Label>
                                      </Col>
                                      <Col xs={9} lg={3}>
                                        <Select
                                          options={unitSales}
                                          getOptionLabel={(option) => option.name_sale}
                                          getOptionValue={(option) => option.id}
                                          placeholder=""
                                          isClearable={false}
                                          isSearchable={false}
                                          value={item.UnitSaleId ? unitSales.find((data) => {return data.id === item.UnitSaleId}) : null}
                                          onChange={
                                            (e) => setData(prevState => ({...Data,
                                              StorageList: prevState.StorageList.map(
                                                el => el.key === item.key ? { ...el, UnitSaleId: e.id }: el
                                              )
                                            }))
                                          }
                                          className="select-list"
                                        />
                                      </Col>
                                    <Col
                                      xs={3}
                                      lg={2}
                                      className="set-Label"
                                    >
                                      <Form.Label>จำนวน</Form.Label>
                                    </Col>
                                    <Col xs={9} lg={4} xl={2}>
                                      <Form.Control className="input-form" 
                                        value={item.Quantity ? item.Quantity : ''}
                                        // onChange={(data) => SetData({...Data, Quantity: data })}
                                        onChange={
                                          (e) => setData(prevState => ({...Data,
                                            StorageList: prevState.StorageList.map(
                                              el => el.key === item.key ? { ...el, Quantity: e.target.value }: el
                                            )
                                          }))
                                        }
                                      ></Form.Control>
                                    </Col>
                                    <Col xs={3} lg={2} xl={1} className="set-Label">
                                      <Form.Label>วันที่โอน</Form.Label>
                                    </Col>
                                    <Col xs={9} lg={4} xl={2}>
                                      <DatePicker
                                        format={dateFormat}
                                        value={item.StockDate}
                                        onChange={
                                          (e) => setData(prevState => ({...Data,
                                            StorageList: prevState.StorageList.map(
                                              el => el.key === item.key ? { ...el, StockDate: e }: el
                                            )
                                          }))
                                        }
                                        placeholder=""
                                        suffixIcon={<img src={Calendar} />}
                                      />
                                    </Col>
                                    <Col xs={3} lg={2} xl={2} className="set-Label set-text-by">
                                      <Form.Label>โอนโดย</Form.Label>
                                    </Col>
                                    <Col xs={9} lg={4} xl={3}>
                                      {/* <Select
                                        options={Employees}
                                        getOptionLabel={(option) => option.fullname}
                                        getOptionValue={(option) => option.id}
                                        placeholder=""
                                        isClearable={false}
                                        isSearchable={false}
                                        onChange={
                                          (e) => setData(prevState => ({...Data,
                                            StorageList: prevState.StorageList.map(
                                              el => el.key === item.key ? { ...el, CountBy: e.id }: el
                                            )
                                          }))
                                        }
                                        className="select-list"
                                      /> */}
                                       <Select
                                        options={employees}
                                        getOptionLabel={(option) => option.fullname}
                                        getOptionValue={(option) => option.id}
                                        placeholder=""
                                        isClearable={false}
                                        isSearchable={false}
                                        onChange={
                                          (e) => setData(prevState => ({...Data,
                                            StorageList: prevState.StorageList.map(
                                              el => el.key === item.key ? { ...el, CountBy: e.id }: el
                                            )
                                          }))
                                        }
                                        className="select-list"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              <Row className="mt-2 mb-2">
                                <Col lg={9}>
                                  <Row className="align-items-start">
                                    <Col
                                      xs={3}
                                      lg={2}
                                      className="d-flex justify-content-end set-Label"
                                    >
                                      <Form.Label>หมายเหตุ</Form.Label>
                                    </Col>
                                    <Col xs={9} lg={5}>
                                      <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={Data.Note}
                                        onChange={
                                          (e) => setData(prevState => ({...Data,
                                            StorageList: prevState.StorageList.map(
                                              el => el.key === item.key ? { ...el, Note: e.target.value }: el
                                            )
                                          }))
                                        }
                                        className="text-area "
                                      ></Form.Control>
                                    </Col>
                                    <Col lg={4} xl={3} className="pt-2">
                                      <Button
                                        type="button"
                                        className="button-delete-menu-stock"
                                        onClick={() => RemoveStorage(item.key)}
                                      >
                                        <img src={Delete} /> &nbsp; ลบรายการ
                                      </Button>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col lg={3} xl={2} className="pt-2">
                                  {
                                      (key+1) === Data.StorageList.length &&
                                      <Row className="align-items-center">
                                      <Col>
                                        <Button
                                          type="button"
                                          className="button-delete-menu-stock"
                                          onClick={() => {InsertStorage(item.key)}}
                                        >
                                          <img src={Increase} />{' '}
                                          &nbsp; เพิ่มรายการ
                                        </Button>
                                      </Col>
                                    </Row>
                                    }
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row
                            className="g-0 mb-5"
                            style={{ border: '1px solid #7A7A7A' }}
                          ></Row>
                        </div>
                      );
                    })
                  }
                
                <Row className="justify-content-between mt-4 mb-4">
                  <Col lg={2}>
                    <Button
                      type="submit"
                      className="button-delete-menu-stock"
                    >
                      <img src={Save} /> &nbsp; บันทึก
                    </Button>
                  </Col>
                  <Col lg={2}>
                    <Button
                      type="button-save"
                      onClick={closePage}
                      className="button-delete-menu-stock"
                    >
                      <img src={Getout} /> &nbsp; ออก
                    </Button>
                  </Col>
                </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
}
